<template>
  <div>
    <div class="category-top-bar">
      <div class="top-bar">
        <p>
          <a class="btn btn-orange btn-icon back" :title="$t('general.back')" @click.prevent="goBack">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
        </p>
        <div class="text-right">
          <p class="d-inline-flex">
            <a v-if="!isNew()" class="btn btn-danger btn-icon btn btn mar-rt-10 delete"  @click.prevent="handleDelete('delete')" :title="$t('general.delete') + ' ' + $t('catalogCateg.single')">
              <img src="/static/img/icons/icon-close.png">
              {{$t('general.delete')}}
            </a>
            <button type="submit" @click.prevent="validate" class="btn btn-icon btn-success btn mar-rt-10 save" :title="$t('general.save')">
                <img src="/static/img/icons/save.png">
                {{$t('general.save')}}
            </button>
          </p>
        </div>
      </div>
    </div>
    <div class="card translations-card">
      <div class="card-content">
        <h5 class="translations-title">{{$t('catalogCateg.name')}} / {{$t('catalogCateg.shortDescription')}}</h5>
        <div class="lang-tabs">
          <a
            class="lang-tab"
            :class="[{ active: currentSubSection === 'l1', errorT: invalidTabs.includes('l1') }]"
            @click.prevent="openSubSection('l1')"
          >{{ language }}</a>
          <a
            v-for="lang in languages"
            :key="'tab-' + lang.id"
            class="lang-tab"
            :class="[{ active: currentSubSection === lang.id + '-' + lang.short, errorT: invalidTabs.includes(lang.id + '-' + lang.short) }]"
            @click.prevent="openSubSection(lang.id + '-' + lang.short)"
          >{{ lang.short }}</a>
        </div>

        <div v-show="currentSubSection === 'l1'">
          <div class="form-group">
            <label>{{$t('catalogCateg.name')}}</label>
            <input type="text"
                  name="name"
                  :placeholder="$t('catalogCateg.name')"
                  v-validate="modelValidations.name"
                  v-model="model.name"
                  class="form-control">
            <small class="text-danger" v-if="errors.has('name')">
              {{ getError('name') }}
            </small>
          </div>
          <div class="form-group">
            <label>{{$t('catalogCateg.shortDescription')}}</label>
            <textarea rows="5"
                  name="description"
                  :placeholder="$t('catalogCateg.shortDescription')"
                  v-model="model.description"
                  class="form-control"></textarea>
          </div>
        </div>

        <template v-for="lang in languages">
          <div
            :key="'box-' + lang.id"
            v-if="model.localized_fields && model.localized_fields[lang.short]"
            v-show="currentSubSection === lang.id + '-' + lang.short"
          >
            <div class="form-group">
              <label>{{$t('catalogCateg.name')}} ({{ lang.short }})</label>
              <input type="text"
                    :placeholder="$t('catalogCateg.name')"
                    v-model="model.localized_fields[lang.short].name"
                    class="form-control">
              <small class="text-danger" v-if="invalidTabs.includes(lang.id + '-' + lang.short) && (!model.localized_fields[lang.short].name || !model.localized_fields[lang.short].name.trim())">
                {{ $t('validations.requiredField') }}
              </small>
            </div>
            <div class="form-group">
              <label>{{$t('catalogCateg.shortDescription')}} ({{ lang.short }})</label>
              <textarea rows="5"
                    :placeholder="$t('catalogCateg.shortDescription')"
                    v-model="model.localized_fields[lang.short].description"
                    class="form-control"></textarea>
            </div>
          </div>
        </template>
      </div>
    </div>

    <div class="card">
      <div :class="(loading ? 'show-loader' : 'hide-loader')">
        <div class="el-loading-spinner">
          <svg viewBox="25 25 50 50" class="circular">
            <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
          </svg><!---->
        </div>
      </div>
      <div class="section-header">
        <h5 class="section-header__title">{{$t('catalogCateg.single')}}</h5>
      </div>
      <form>
        <div class="card-content">
          <div class="row">
            <div class="col-md-6">

              <div class="form-group">
                <label>{{$t('catalogCateg.assignTopCategory')}}</label>
                <select name="top_category_id"
                              class="form-control"
                              data-vv-as="top_category"
                              ref="top_category_id"
                              @change="changeTopCategory()"
                              v-model="model.top_category_id">
                  <option value="null">{{$t('catalogCateg.pleaseSelect')}}</option>
                  <option v-for="option in topCategories"
                              :value="option.id"
                              :label="option.name"
                              :key="option.id">
                  </option>
                </select>
              </div>

              <div class="form-group">
                <label>{{$t('marketingCampaigns.visibleInLocations')}}</label>
                <v-select
                  v-model="selectedLocations"
                  multiple
                  :options="locations"
                  label="name"
                  :placeholder="$t('general.all')"
                  class="line-heigth-44"
                  @input="updateDeliverySettings"
                />
                <small class="text-muted">{{$t('marketingCampaigns.visibleInLocationsInfo')}}</small>
              </div>

              <div class="form-group category-override-group">
                <label><span>{{$t('catalogProd.deliveryMethodsandHours')}}</span></label>
                <div @click="updateDeliverySettings()">
                  <p-checkbox
                    @input="handleChangeOverrideDelivery()"
                    :value="true"
                    v-model="model.override_delivery"
                  >{{$t('catalogProd.overrideSettings')}}</p-checkbox>
                  <small class="text-muted category-override-help">{{$t('catalogCateg.overrideSettingsHelp')}}</small>
                  <small class="text-danger" v-if="model.override_delivery && (errors.has('isCheckedDay') || errors.has('isCheckedDeliveryMethod'))">
                    {{ $t('validations.chooseLocationAndDeliveryMethod') }}
                  </small>
                  <small class="text-danger" v-if="model.override_delivery && errors.has('intervalError')">
                    {{ $t('validations.timeInterval') }}
                  </small>
                </div>

                <el-collapse
                  v-if="model.override_delivery"
                  accordion
                  class="category-override-collapse"
                >
                  <el-collapse-item
                    v-for="(loc, locId) in model.override_settings"
                    v-show="showThisOverrideLocation(loc.loc_id)"
                    :key="'override-' + loc.loc_id + '-' + locId"
                    :title="overrideLocationTitle(loc.loc_id)"
                    :name="String(loc.loc_id)"
                  >
                    <hr class="sm">
                    <template v-for="(orderInterval, orderIntervalId) in loc.delivery">
                      <div class="col-md-12" :key="'dm-' + locId + '-' + orderIntervalId">
                        <h4>
                          {{ $t('settingCompany.' + deliveryMethodLabel(orderInterval, orderIntervalId)) }}
                          <button
                            class="btn btn-success btn-sm"
                            @click.prevent="addNewOverrideInterval(locId, orderIntervalId, deliveryMethodLabel(orderInterval, orderIntervalId))"
                          >+</button>
                        </h4>

                        <template v-for="(order, orderId) in orderInterval">
                          <div class="col-md-12" :key="'interval-' + locId + '-' + orderIntervalId + '-' + orderId">
                            <p-checkbox
                              @input="handleChangeIsCheckedDeliveryMethod(locId, orderIntervalId, orderId)"
                              v-model="model.override_settings[locId]['delivery'][orderIntervalId][orderId]['active']"
                              :value="model.override_settings[locId]['delivery'][orderIntervalId][orderId]['active']"
                            >
                              {{ $t('general.active') }}
                            </p-checkbox>

                            {{ $t('general.from') }}
                            <el-time-select
                              :disabled="!model.override_settings[locId]['delivery'][orderIntervalId][orderId]['active']"
                              placeholder="Select time"
                              v-model="model.override_settings[locId]['delivery'][orderIntervalId][orderId]['available_from']"
                              class="in-inline-160"
                              :picker-options="timePickerOptions"
                            />

                            {{ $t('general.to') }}
                            <el-time-select
                              :disabled="!model.override_settings[locId]['delivery'][orderIntervalId][orderId]['active']"
                              placeholder="Select time"
                              v-model="model.override_settings[locId]['delivery'][orderIntervalId][orderId]['available_to']"
                              class="in-inline-160"
                              :picker-options="timePickerOptions"
                            />

                            <button
                              class="btn btn-danger btn-sm"
                              @click.prevent="removeOverrideInterval(locId, orderIntervalId, orderId)"
                            >-</button>
                          </div>

                          <div class="col-md-12 pull-left-first-child" style="flex-wrap:wrap;" :key="'days-' + locId + '-' + orderIntervalId + '-' + orderId">
                            <template v-for="(d, key) in weekDays()">
                              <p-checkbox
                                :key="'day-' + locId + '-' + orderIntervalId + '-' + orderId + '-' + key"
                                @input="handleCheckDay(locId, orderIntervalId, orderId)"
                                :disabled="!model.override_settings[locId]['delivery'][orderIntervalId][orderId]['active']"
                                class="inline-auto mar-rt-5"
                                v-model="model.override_settings[locId]['delivery'][orderIntervalId][orderId][d.toLowerCase()]"
                                :value="d"
                              >
                                {{ $t('catalogProd.' + d) }}
                              </p-checkbox>
                            </template>
                          </div>

                          <div class="col-md-12 pull-left-first-child" style="flex-wrap:wrap;" :key="'day-err-' + locId + '-' + orderIntervalId + '-' + orderId">
                            <small
                              class="text-danger"
                              v-if="model.override_settings[locId]['delivery'][orderIntervalId][orderId]['active'] &&
                                    !model.override_settings[locId]['delivery'][orderIntervalId][orderId].monday &&
                                    !model.override_settings[locId]['delivery'][orderIntervalId][orderId].tuesday &&
                                    !model.override_settings[locId]['delivery'][orderIntervalId][orderId].wednesday &&
                                    !model.override_settings[locId]['delivery'][orderIntervalId][orderId].thursday &&
                                    !model.override_settings[locId]['delivery'][orderIntervalId][orderId].friday &&
                                    !model.override_settings[locId]['delivery'][orderIntervalId][orderId].saturday &&
                                    !model.override_settings[locId]['delivery'][orderIntervalId][orderId].sunday"
                            >
                              {{ $t('validations.chooseDay') }}
                            </small>
                          </div>
                        </template>
                      </div>
                    </template>
                  </el-collapse-item>
                </el-collapse>
              </div>

              <div class="form-group">
                <label>{{$t('catalogCateg.vat')}}</label>
                <input type="number"
                      min="0"
                      :placeholder="$t('catalogProd.price')"
                      v-model="model.vat"
                      class="form-control">
              </div>

              <div class="form-group">
                <label>{{$t('catalogCateg.preparation_time_in_minutes')}}</label>
                <input type="number"
                      min="0"
                      step="1"
                      name="preparation_time_in_minutes"
                      :placeholder="$t('catalogCateg.preparation_time_in_minutes')"
                      v-model="preparationTimeInMinutes"
                      class="form-control">
              </div>

              <div class="form-group">
                <label>Selecteaza filtre relevante pentru categorie</label>
                <br/>
                <v-select v-model="model.filters"
                  multiple
                  :options="filters"
                  value="id"
                  label="type"
                  :ref="'option'"
                  :placeholder="$t('general.none')"
                  class=""
                  :key="'option'">
                  </v-select>
              </div>

              <div v-if="userLabelings.length" class="form-group">
                <label>{{$t('catalogCateg.userLabelings')}}</label>
                <v-select
                  v-model="selectedUserLabelings"
                  multiple
                  :options="userLabelings"
                  label="name"
                  :reduce="item => item.id"
                  :placeholder="$t('general.none')"
                  class="line-heigth-44"
                />
                <small class="text-muted">{{$t('catalogCateg.userLabelingsHelp')}}</small>
              </div>

              <div class="form-group">
                <label>{{$t('catalogCateg.notification_email')}}</label>
                <input type="text"
                      name="notification_email"
                      :placeholder="$t('catalogCateg.notification_email')"
                      v-model="model.notification_email"
                      class="form-control">
                <small class="text-danger" v-if="errors.has('notification_email')">
                  {{ getError('notification_email') }}
                </small>
              </div>

              <div class="form-group">
                <label>{{$t('catalogCateg.displayType')}}</label>
                <br/>
                <p-radio v-for="(opt, key) in displayTypes"
                  :key="key"
                  v-model="model.display_type"
                  :label="key"
                  :inline="true"
                  :disabled="key === 'grid'">{{$t('catalogCateg.'+ opt)}}</p-radio>
                <small class="text-danger" v-if="errors.has('display_type')">
                  {{ getError('display_type') }}
                </small>
              </div>
              <!-- <div class="form-group">
                <label>Parent Category</label>
                <select name="parent_id" class="form-control"
                              v-model="model.parent_id">
                  <option :value="null" :selected="true">None</option>
                  <template v-for="option in mainCategories">
                    <option v-if="option.id != $route.params.id"
                              :selected="option.id === model.parent_id"
                              :value="option.id"
                              :label="option.name"
                              :key="option.id"></option>
                  </template>
                </select>
                <small class="text-danger" v-if="errors.has('parent_id')">
                  {{ getError('parent_id') }}
                </small>
              </div> -->
              <div class="form-group">
                <label>{{$t('catalogCateg.color')}}</label>
                <ChromePicker
                  :value="model.color || '#FFFFFF'"
                  :disable-alpha="true"
                  @input="$set(model, 'color', $event.hex)"
                />
              </div>
              <div class="form-group">
                <label>{{$t('catalogCateg.validFromTo')}}</label>
                <el-date-picker type="daterange"
                                v-model="model.fromto"
                                value-format="yyyy-MM-dd"
                                format="dd/MM/yyyy"
                                :picker-options="pickerOptions">
                </el-date-picker>
                <small class="text-danger" v-if="errors.has('date_validfrom')">
                  {{ getError('date_validfrom') }}
                </small>
              </div>

              <div class="form-group">
                <p-checkbox
                  @input="showMethods()"
                  :disabled = "(model.top_category_id !== 'null' && model.top_category_id !== null) ? true : false "
                  key="forceMethod"
                  v-model="model.is_force_method"
                  class="text-purple"
                  label="forceMethod">
                <span ref="interval" class="pad-to-7" style="margin: 4px;" name="forceMethod">{{$t('catalogCateg.forceMethod')}}
                  <span v-if="(model.top_category_id !== 'null' && model.top_category_id !== null)">{{$t('catalogCateg.enableMethod')}}</span></span>
                </p-checkbox>
                <template v-if="model.is_force_method">
                  <label class="selectMethod" for="methods">
                      {{$t('catalogCateg.selectMethod')}}
                    <el-select
                      v-if="delivery_options_labels.length"
                      key="methods"
                      name="methods"
                      v-model="model.force_methods"
                      v-validate="(model.is_force_method) ? 'required' : ''"
                      multiple
                      filterable
                      default-first-option
                      :placeholder="$t('general.add')">
                      <template v-for="item in delivery_options_labels">
                            <el-option
                              :label="item.label"
                              :value="item.key">
                            </el-option>
                      </template>
                    </el-select>
                  </label>
                </template>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>{{$t('catalogCateg.image')}}</label>
                <el-upload
                  action=""
                  ref="upload"
                  :limit="2"
                  :file-list="model.imagelist"
                  list-type="picture-card"
                  accept=" .jpg, .jpeg, .png"
                  :on-change="handleImgChange"
                  :on-exceed="handleExceed"
                  :on-remove="handleRemove"
                  :auto-upload="false">
                  <img src="/static/img/icons/icon-plus-primary.png">
                  <div class="el-upload__tip" slot="tip">{{$t('validations.pictureSize')}}</div>
                </el-upload>
              </div>
              <div class="form-group">
                <p-switch v-model="model.active" type="success"></p-switch>
                <label>{{$t('settingLocationGroups.active')}}</label>
              </div>
              <div class="form-group">
                <label>{{$t('catalogCateg.disabledOrderSources')}}</label>
                <v-select
                  v-model="selectedDisabledOrderSources"
                  multiple
                  :options="disablableOrderSources"
                  label="name"
                  :placeholder="$t('catalogProd.timeOptionsValues.none')"
                  class="line-heigth-44"
                />
                <small class="text-muted">{{$t('catalogCateg.disabledOrderSourcesHelp')}}</small>
              </div>
              <div class="form-group">
                <p-switch v-model="model.no_discount_allowed" type="success"></p-switch>
                <label>{{$t('catalogCateg.no_discount_allowed')}}</label>
              </div>
              <div class="form-group">
                <p-switch v-model="model.is_age_restrict" type="success"></p-switch>
                <label>{{$t('catalogCateg.isAgeRestrict')}}</label>
              </div>
              <div v-if="!this.isNew()" class="form-group">
                {{$t('catalogCateg.deleteProducts')}}
                <button class="btn btn-danger btn-icon delete-prod mar-to--5 mar-lt-5"
                  @click.prevent="deleteProducts()">
                  <i class="ti-trash"></i>
                </button>
              </div>

              <div v-if="has_charisma_location" class="mar-bt-15">
                <h6>{{ $t('charisma.charismaInventory') }}</h6>
                <table class="table">
                  <thead>
                    <tr>
                      <th>{{ $t('general.administration') }}</th>
                      <th>{{ $t('marketingCampaigns.locations') }}</th>
                      <th>{{ $t('general.actions') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="!administrations || !administrations.length">
                      <td colspan="3" class="text-center text-muted">
                        {{ $t('general.noAdministrationsAvailable') }}
                      </td>
                    </tr>
                    <tr v-if="administrations && administrations.length && (!model.administrations || !model.administrations.length)">
                      <td colspan="3" class="text-center text-muted">
                        {{ $t('general.setAdministration') }}
                      </td>
                    </tr>
                    <tr v-for="(row, index) in model.administrations" :key="index">
                      <td>
                        <select
                          v-model="row.administration_id"
                          class="form-control"
                          :placeholder="$t('general.select')"
                        >
                          <option :value="null" disabled>{{ $t('general.select') }}</option>
                          <option
                            v-for="admin in availableAdministrations(row.administration_id)"
                            :value="admin.id"
                            :key="admin.id"
                          >
                            {{ admin.name }}
                          </option>
                        </select>
                        <small v-if="errors.has(`administration_id_${index}`)" class="text-danger">
                          {{ getError(`administration_id_${index}`) }}
                        </small>
                      </td>
                      <td>
                        <v-select
                          v-model="row.location_ids"
                          :options="locations"
                          multiple
                          label="name"
                          :reduce="loc => loc.id"
                          :placeholder="$t('settingsOrdering.selectLocations')"
                        />
                      </td>
                      <td>
                        <button class="btn btn-danger btn-icon delete-prod mar-to--5 mar-lt-5"
                          @click.prevent="removeRow(index)">
                          <i class="ti-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <button v-if="administrations && administrations.length && (!model.administrations || (model.administrations && model.administrations.length < administrations.length))" class="btn btn-primary" @click.prevent="addRow">
                  <img src="/static/img/icons/add.png" />
                  {{ $t('general.add') }}
                </button>
              </div>

              <template v-if="use_gestiune && model.selectedGestiuni">
                <br>
                <div class="mar-bt-15">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>{{ $t('marketingCampaigns.locations') }}</th>
                        <th>{{ $t('general.administration') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(location, index) in locationsForGestiune"
                        :key="location.id"
                      >
                        <td>{{ location.name }}</td>
                        <td>
                          <select
                            class="form-control"
                            v-model="model.selectedGestiuni[location.true_id]"
                            :disabled="!gestiuni[location.true_id]"
                          >
                            <option :value="null"> {{ $t('general.select') }} </option>
                            <option
                              v-for="admin in gestiuni[location.true_id] || []"
                              :value="admin._id"
                              :key="admin._id"
                            >
                              {{ admin.name }}
                            </option>
                          </select>
                        </td>
                      </tr>
                      <tr v-if="!locationsForGestiune || !locationsForGestiune.length">
                        <td colspan="2" class="text-center text-muted">
                          No Locations Available
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <br>
              </template>


              <div class="form-group">
                <label>{{$t('catalogProd.hideFromPlatforms')}}</label>
                <v-select
                  v-model="selectedPlatforms"
                  multiple
                  :options="platforms"
                  label="name"
                  :placeholder="$t('catalogProd.timeOptionsValues.none')"
                  class="line-heigth-44"
                />
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="card reward-card">
      <div class="section-header">
        <img src="/static/img/icons/points-sm.png" class="section-header__icon">
        <h5 class="section-header__title">{{$t('catalogProd.rewardPoints')}}</h5>
      </div>
      <div class="card-content">
        <p class="reward-card__help">
          {{$t('catalogProd.numberOfYouNeedToSpend', { currency: currency })}}
        </p>
        <div class="reward-card__control">
          <span>1&nbsp;{{currency}}&nbsp;=</span>
          <input type="number"
                min="0"
                step="0.1"
                name="monetary_conversion"
                v-model="model.monetary_conversion"
                class="form-control">
          <span>{{$t('catalogProd.points')}}</span>
        </div>
      </div>
    </div>

    <div class="card" v-if="sortProductMethod == 'custom' && !isNew()">
      <div class="section-header">
        <h5 class="section-header__title">{{$t('general.customSort')}}</h5>
      </div>
      <div class="card-content">
        <div class="row">
          <table class="table mar-lt-15" style="width: 50%" ref="sortableTable">
            <thead>
              <tr>
                <th width="30%">{{$t('general.sortOrder')}}</th>
                <th width="70%">{{$t('catalogCateg.name')}}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in tableData"
                :key="'product-sort-' + item.id"
                class="sortableRow"
              >
                <td>
                  <input
                    type="number"
                    min="0"
                    max="1000"
                    :placeholder="$t('general.sortOrder')"
                    v-model="item.sort_order"
                    step="1"
                    @input="onSortOrderInput(item)"
                    @keypress="onlyDigits($event)"
                    @click="selectInputText($event)"
                    class="form-control"
                  >
                </td>
                <td>
                  {{ item.name }}
                  <span
                    v-if="item.is_secondary == 1 || item.is_secondary === true"
                    class="text-muted"
                    style="font-size: 12px; margin-left: 6px;"
                  >({{ $t('catalogCateg.secondaryMember') }})</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import { Chrome } from 'vue-color'
  import {mapFields} from 'vee-validate'
  import {Input, Upload, Button, DatePicker, Checkbox, CheckboxGroup, Dialog, TimeSelect} from 'element-ui'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import moment from 'moment'
  import swal from 'sweetalert2'
  import vSelect from 'vue-select'
  import 'sweetalert2/dist/sweetalert2.css'
  Vue.component('v-select', vSelect)
  Vue.use(DatePicker)
  Vue.use(Upload)
  Vue.use(Button)
  Vue.use(Input)
  Vue.use(Checkbox)
  Vue.use(CheckboxGroup)
  Vue.use(Dialog)
  Vue.use(TimeSelect)

  export default {
    components: {
      ChromePicker: Chrome,
      [DatePicker.name]: DatePicker,
      [Upload.name]: Upload,
      [Button.name]: Button,
      [Input.name]: Input,
      [Checkbox.name]: Checkbox,
      [CheckboxGroup.name]: CheckboxGroup,
      [Dialog.name]: Dialog,
      [TimeSelect.name]: TimeSelect,
      PSwitch
    },
    computed: {
      ...mapFields(['name', 'notification_email', 'description', 'sort_order', 'parent_id', 'date_validfrom', 'date_validto', 'display_type']),
      currency () {
        const companyData = this.$session.get('selectedCompanyData')
        return companyData ? this.getCurrencySymbol(companyData.currency_iso) : ''
      },
      preparationTimeInMinutes: {
        get () {
          if (this.model.preparation_time_in_seconds === null || this.model.preparation_time_in_seconds === undefined || this.model.preparation_time_in_seconds === '') {
            return null
          }
          return Number(this.model.preparation_time_in_seconds) / 60
        },
        set (minutes) {
          if (minutes === null || minutes === undefined || minutes === '') {
            this.$set(this.model, 'preparation_time_in_seconds', null)
            return
          }
          this.$set(this.model, 'preparation_time_in_seconds', Math.round(Number(minutes) * 60))
        }
      }
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        currentSubSection: 'l1',
        invalidTabs: [],
        language: '',
        languages: [],
        delivery_options_labels: false,
        originalLocationIds: [],
        selectedLocations: [],
        pickerOptions1: {
          // onPick (dates) {
            // if (dates.minDate !== 'undefined' && dates.maxDate !== 'undefined') {
            //   console.warn(this)
            //   this.updateDates(dates)
            // }
          // }
        },
        deliveryServices: [],
        pickerNames: ['date_validfrom', 'date_validto'],
        pickerOptions: {
          disabledDate (time) {
            if ((time.getTime() + 86401 * 1000) < Date.now()) {
              return true
            } else {
              return false
            }
          }
        },
        displayTypes: {
          'list': 'List',
          'grid': 'Grid'
        },
        mainCategories: [],
        topCategories: [],
        model: {
          parent_id: null,
          color: null,
          display_type: 'list',
          override_delivery: false,
          override_settings: [],
          is_age_restrict: false
        },
        filelist: [],
        filelistToUpload: [],
        generalSuccess: '',
        modelValidations: {
          name: {
            required: true
          }
        },
        loading: true,
        sortProductMethod: null,
        tableData: [],
        sortOrderChanges: {},
        debounceTimeout: null,
        filters: [],
        deleteImage: false,
        use_gestiune: false,
        has_charisma_location: false,
        locationsForGestiune: [],
        gestiuni: [],
        locations: [],
        overrideLocations: [],
        deleteOverrides: [],
        isCheckedDay: false,
        isCheckedDeliveryMethod: false,
        timePickerOptions: {
          start: '00:00',
          step: '00:15',
          end: '23:59'
        },
        administrations: [],
        administrationsToDelete: [],
        platforms: [
          {id: 1, name: this.$t('addOrder.application')},
          {id: 2, name: 'Website'},
          // {id: 3, name: 'ADMIN'},
          // {id: 4, name: 'KIOSK'},
          // {id: 5, name: 'POS'},
          {id: 6, name: 'QR'}
        ],
        selectedPlatforms: [],
        userLabelings: [],
        selectedUserLabelings: [],
        // order source ids (API config inmobito.order_sources): 1 kiosk, 2 qr, 3 pos, 4 app, 5 website
        // only QR and POS for now; add the others here when the API allows them (Catalogcategory::DISABLABLE_ORDER_SOURCES)
        disablableOrderSources: [
          {id: 2, name: 'QR'},
          {id: 3, name: 'POS'}
        ],
        selectedDisabledOrderSources: []
      }
    },
    created: function () {
      this.$nextTick(function () {
        this.loading = true
      })
      this.use_gestiune = this.$session.get('selectedCompanyData').use_gestiune
      this.ensureCompanyLocationFlags((sessionData) => {
        this.has_charisma_location = !!sessionData.has_charisma_location
      })
      if (this.use_gestiune) {
        this.fetchLocationsForGestiune()
      }
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      var self = this
      this.loadLanguages()
      // get main categories
      // this.apiRequest('/category', 'GET', data, function (response) {
      //   if (response.status === true) {
      //     self.mainCategories = response.data
      //   }
      // })

      let sessionData = this.$session.get('selectedCompanyData')

      this.overrideLocations = sessionData['locations_details'] || []

      if (!sessionData['locations_list']) {
        let locationsDetails = sessionData['locations_details'] || []

        let locationsList = locationsDetails.map(location => ({
          id: location.true_id,
          name: location.name
        }))

        this.locations = locationsList
        sessionData['locations_list'] = locationsList

        this.$session.set('selectedCompanyData', sessionData)
      } else {
        this.locations = sessionData['locations_list']
      }

      if (!sessionData['administrations']) {
        this.apiRequest('/administration', 'GET', data, (response) => {
          if (response.status) {
            sessionData['administrations'] = response.data
            this.administrations = response.data
            this.$session.set('selectedCompanyData', sessionData)
          }
        })
      } else {
        this.administrations = sessionData['administrations']
      }

      self.sortProductMethod = sessionData.sort_product_method
      // Ensure we have the latest company sort setting (session can be stale locally)
      this.apiRequest('/settings/general/' + this.$session.get('selectedCompany'), 'GET', {
        token: this.$session.get('token')
      }, (response) => {
        if (response.status === true && response.data && response.data[0]) {
          const method = response.data[0].sort_product_method
          if (method !== undefined && method !== null) {
            self.sortProductMethod = method
            sessionData.sort_product_method = method
            self.$session.set('selectedCompanyData', sessionData)
          }
        }
      })
      this.getProducts()
      this.getFilters()
      this.fetchUserLabelings()
      // get category data
      this.apiRequest('/topcategory', 'GET', data, function (response) {
        if (response.status === true) {
          self.topCategories = response.data
        }
        self.$nextTick(function () { self.loading = false })
      })
      if (this.route.params.id) {
        var id = this.route.params.id
        this.apiRequest('/category/' + id, 'GET', data, (response) => {
          if (response.status === true) {
            if (response.data[0].date_validfrom && response.data[0].date_validto) {
              response.data[0].fromto = [response.data[0].date_validfrom, response.data[0].date_validto]
            }
            if (response.data[0].image) {
              response.data[0].imagelist = [{url: response.data[0].image}]
            } else {
              response.data[0].imagelist = []
            }
            // force list display
            response.data[0].display_type = 'list'
            self.model = response.data[0]
            self.model.override_delivery = !!(
              self.model.override_delivery === true ||
              self.model.override_delivery === 1 ||
              self.model.override_delivery === '1'
            )
            if (!Array.isArray(self.model.override_settings)) {
              self.model.override_settings = []
            }
            self.deleteOverrides = []

            // Initialize locations selection (similar to TopCategoryForm)
            const respLocations = response.data[0].locations

            if (respLocations && respLocations.length) {
              this.originalLocationIds = respLocations.slice()
              this.selectedLocations = respLocations
                .map(item => {
                  return this.locations.find(loc => loc.id === item.location_id)
                })
                .filter(Boolean)
            } else {
              this.originalLocationIds = []
              this.selectedLocations = []
            }

            if (!self.model.selectedGestiuni) {
              self.model.selectedGestiuni = {}
            }
            this.locations.forEach(loc => {
              if (!(loc.id in self.model.selectedGestiuni)) {
                self.model.selectedGestiuni[loc.id] = null
              }
            })

            this.mapLocationIdsToObjects()
            self.delivery_options_labels = response.data[0].company.delivery_options_labels

            self.changeTopCategory()

            if (this.model.hide_from_platforms && this.model.hide_from_platforms.length) {
              this.selectedPlatforms = this.model.hide_from_platforms.map(t => this.platforms.find(f => f.id === t)) || []
            }

            if (Array.isArray(self.model.user_labeling_ids)) {
              self.selectedUserLabelings = self.model.user_labeling_ids
                .map(id => self.userLabelings.find(ul => ul.id === id))
                .filter(Boolean)
            }

            this.selectedDisabledOrderSources = (this.model.disabled_order_sources || [])
              .map(id => this.disablableOrderSources.find(source => source.id === Number(id)))
              .filter(Boolean)

            self.initLocalizedFields()
            self.updateDeliverySettings()

            self.$nextTick(function () { self.loading = false })
          }
        })
      } else {
        self.model.override_delivery = false
        self.model.override_settings = []
        self.deleteOverrides = []
        self.$nextTick(function () { self.loading = false })
      }

      var allTypes = this.$session.get('defaultData')['delivery_types']
      var locations = sessionData['locations_details']

      var enabled = []
      var enabledTypes = []

      for (let loc of locations) {
        for (let ordering of loc['ordering_management']) {
          // console.warn(ordering)
          if (ordering['enabled'] === true) {
            enabled[ordering['type']] = true
          }
        }
      }
      for (let idx in allTypes) {
        if (enabled[idx.toLowerCase()] !== undefined) {
          enabledTypes.push(allTypes[idx])
        }
      }
      this.deliveryServices = enabledTypes
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      loadLanguages () {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/company-data', 'GET', data, (response) => {
          if (response.status === true && response.data && response.data.company) {
            this.languages = response.data.company.languages || []
            this.language = response.data.company.language || ''
            this.initLocalizedFields()
          }
        })
      },
      openSubSection (section) {
        this.currentSubSection = section
      },
      initLocalizedFields () {
        if (!this.languages || !this.languages.length) {
          return
        }
        if (!this.model.localized_fields || Array.isArray(this.model.localized_fields)) {
          this.$set(this.model, 'localized_fields', {})
        }
        this.languages.forEach(lang => {
          if (!this.model.localized_fields[lang.short]) {
            this.$set(this.model.localized_fields, lang.short, {
              language_id: lang.id,
              language_short: lang.short,
              name: '',
              description: ''
            })
          } else {
            this.model.localized_fields[lang.short].language_id = lang.id
            this.model.localized_fields[lang.short].language_short = lang.short
          }
        })
      },
      validateLocalizedNames () {
        // Name is required for the base language and for every company language.
        this.invalidTabs = []
        let firstInvalidTab = null

        if (!this.model.name || !String(this.model.name).trim()) {
          this.invalidTabs.push('l1')
          firstInvalidTab = 'l1'
        }

        this.languages.forEach(lang => {
          const lf = this.model.localized_fields ? this.model.localized_fields[lang.short] : null
          const tabKey = lang.id + '-' + lang.short
          if (!lf || !lf.name || !String(lf.name).trim()) {
            if (!this.invalidTabs.includes(tabKey)) {
              this.invalidTabs.push(tabKey)
            }
            if (!firstInvalidTab) {
              firstInvalidTab = tabKey
            }
          }
        })

        if (firstInvalidTab) {
          this.currentSubSection = firstInvalidTab
        }

        return this.invalidTabs.length === 0
      },
      fetchLocationsForGestiune () {
        const dataToSend = {
          company_id: this.$session.get('selectedCompany'),
          token: this.$session.get('token')
        }
        this.apiRequest('/gestiune/locations', 'GET', dataToSend, (response) => {
          // if (!response || response.status !== true || !response.data || !response.data.locations) {
          //   swal({
          //     title: 'Eroare!',
          //     text: response.message || 'Eroare la preluarea locațiilor.',
          //     type: 'error',
          //     timer: 3000,
          //     showConfirmButton: false
          //   })
          //   return
          // }
          this.locationsForGestiune = response.data.locations
          this.locationsForGestiune.forEach(loc => {
            this.getGestiuneForLocation(loc.true_id, loc.inv_fiscal_code)
          })
        })
      },
      async getGestiuneForLocation (locationId, vatNr) {
        if (!this.gestiuni[locationId]) {
          let companyId = this.$session.get('selectedCompany')
          try {
            const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/gestiuni?externalCompanyId=${companyId}&vatNumber=${vatNr}&externalLocationId=${locationId}`)
            const data = await response.json()

            if (data && data.gestiuni && Array.isArray(data.gestiuni)) {
              this.gestiuni[locationId] = data.gestiuni
            } else {
              // swal({
              //   title: 'Error!',
              //   text: 'Nu s-a primit un array valid de la server.',
              //   type: 'error',
              //   timer: 2000,
              //   showConfirmButton: false
              // })
            }
          } catch (error) {
            // swal({
            //   title: 'Error!',
            //   text: `Request failed: ${error.message}`,
            //   type: 'error',
            //   timer: 2000,
            //   showConfirmButton: false
            // })
            // console.error('Error fetching management data:', error)
          }
        }
      },
      deleteProducts () {
        var self = this

        swal({
          text: this.$t('catalogCateg.areYouSureDeleteProducts'),
          type: 'question',
          showCancelButton: true
        })
        .then((result) => {
          if (result) {
            var data = {
              category_id: this.route.params.id,
              token: this.$session.get('token'),
              company_id: this.$session.get('selectedCompany')
            }
            this.apiRequest('/delete-category-products/', 'DELETE', data, function (response) {
              if (response.status === true) {
                swal(
                  '',
                  self.$t('catalogCateg.prodDeleted'),
                  'success'
                )
              } else {
                swal(
                  '',
                  response.errors['id'] ? response.errors['id'] : self.$t('validations.wentWrong'),
                  'error'
                )
              }
            })
          }
        })
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          // this.$emit('on-submit', this.registerForm, isValid)

          if (this.has_charisma_location && this.model.administrations && this.model.administrations.length) {
            this.model.administrations.forEach((row, index) => {
              const fieldName = `administration_id_${index}`

              this.errors.remove(fieldName)

              if (!row.administration_id) {
                this.errors.add({
                  field: fieldName,
                  msg: this.$t('validations.requiredField')
                })
                isValid = false
              } else {
                this.errors.remove(fieldName)
              }
            })
          }

          const localizedValid = this.validateLocalizedNames()
          if (!localizedValid) {
            isValid = false
          }

          if (this.model.override_delivery && (this.errors.has('isCheckedDay') || this.errors.has('isCheckedDeliveryMethod'))) {
            isValid = false
          }

          if (isValid) {
            this.errors.clear()
            this.saveCategory()
          } else if (!localizedValid) {
            swal({
              title: '',
              text: 'Numele este obligatoriu pentru toate limbile.',
              type: 'error',
              timer: 3000,
              showConfirmButton: false
            }).catch(() => {})
          }
        })
      },
      addNewOverrideInterval (locId, deliveryMethod, deliveryMethodLabel) {
        if (!this.model.override_settings[locId]['delivery'][deliveryMethod]) {
          Vue.set(this.model.override_settings[locId]['delivery'], deliveryMethod, [])
        }
        this.model.override_settings[locId]['delivery'][deliveryMethod].push(
          this.createEmptyOverrideInterval(deliveryMethodLabel)
        )
      },
      removeOverrideInterval (locId, deliveryMethod, intervalIndex) {
        if (this.model.override_settings[locId]['delivery'][deliveryMethod][intervalIndex].id) {
          this.deleteOverrides.push(this.model.override_settings[locId]['delivery'][deliveryMethod][intervalIndex].id)
        }
        this.model.override_settings[locId]['delivery'][deliveryMethod].splice(intervalIndex, 1)
      },
      handleCheckDay (locId, intervalId, orderId) {
        let check = this.model.override_settings[locId]['delivery'][intervalId][orderId]['active'] &&
          !this.model.override_settings[locId]['delivery'][intervalId][orderId].monday &&
          !this.model.override_settings[locId]['delivery'][intervalId][orderId].tuesday &&
          !this.model.override_settings[locId]['delivery'][intervalId][orderId].wednesday &&
          !this.model.override_settings[locId]['delivery'][intervalId][orderId].thursday &&
          !this.model.override_settings[locId]['delivery'][intervalId][orderId].friday &&
          !this.model.override_settings[locId]['delivery'][intervalId][orderId].saturday &&
          !this.model.override_settings[locId]['delivery'][intervalId][orderId].sunday

        this.isCheckedDay = !check

        if (!this.isCheckedDay && this.model.override_delivery) {
          this.errors.add('isCheckedDay', 'Day is required.')
          return false
        } else {
          if (this.errors.items.length) {
            this.errors.items = this.errors.items.filter(element => {
              return element.field !== 'isCheckedDay'
            })
          }
        }
      },
      handleChangeIsCheckedDeliveryMethod (locId, orderIntervalId, orderId) {
        let hasActive = false
        const delivery = this.model.override_settings[locId]['delivery']
        const groups = Array.isArray(delivery) ? delivery : Object.values(delivery || {})
        groups.forEach((group) => {
          if (Array.isArray(group)) {
            group.forEach((interval) => {
              if (interval && (interval.active === true || interval.active === 1)) {
                hasActive = true
              }
            })
          } else if (group && (group.active === true || group.active === 1)) {
            hasActive = true
          }
        })

        this.isCheckedDeliveryMethod = !hasActive
        this.handleChangeOverrideDelivery()
        if (orderIntervalId !== undefined && orderId !== undefined) {
          this.handleCheckDay(locId, orderIntervalId, orderId)
        }
      },
      handleChangeOverrideDelivery () {
        if (this.isCheckedDeliveryMethod && this.model.override_delivery) {
          this.errors.add('isCheckedDeliveryMethod', 'Location is required.')
        } else {
          if (this.errors.items.length) {
            this.errors.items = this.errors.items.filter(element => {
              return element.field !== 'isCheckedDeliveryMethod'
            })
          }
        }
      },
      createEmptyOverrideInterval (deliveryMethod) {
        return {
          active: true,
          monday: false,
          tuesday: false,
          wednesday: false,
          thursday: false,
          friday: false,
          saturday: false,
          sunday: false,
          delivery_method: deliveryMethod,
          available_from: '',
          available_to: ''
        }
      },
      deliveryMethodLabel (orderInterval, orderIntervalId) {
        if (orderInterval && orderInterval[0] && orderInterval[0].delivery_method) {
          return orderInterval[0].delivery_method
        }
        return orderIntervalId
      },
      getLocationOrderingManagement (loc) {
        if (loc && Array.isArray(loc.ordering_management) && loc.ordering_management.length) {
          return loc.ordering_management
        }

        const allTypes = (this.$session.get('defaultData') || {}).delivery_types || {}
        const methods = []

        if (Array.isArray(allTypes)) {
          allTypes.forEach((type) => {
            const method = typeof type === 'string' ? type : (type && (type.key || type.type))
            if (method) {
              methods.push({ type: String(method).toLowerCase() })
            }
          })
        } else if (allTypes && typeof allTypes === 'object') {
          Object.keys(allTypes).forEach((key) => {
            methods.push({ type: String(key).toLowerCase() })
          })
        }

        if (!methods.length) {
          return [
            { type: 'pick_up' },
            { type: 'delivery' },
            { type: 'eat_in' }
          ]
        }

        return methods
      },
      buildLocationDeliveryMap (loc, existingDelivery) {
        let delivery = {}

        // Keep only real intervals that already exist (from API or user-added)
        if (Array.isArray(existingDelivery)) {
          existingDelivery.forEach((group) => {
            if (!Array.isArray(group) || !group.length || !group[0] || !group[0].delivery_method) {
              return
            }
            const method = group[0].delivery_method
            delivery[method] = group.slice()
          })
        } else if (existingDelivery && typeof existingDelivery === 'object') {
          Object.keys(existingDelivery).forEach((method) => {
            const group = existingDelivery[method]
            delivery[method] = Array.isArray(group) ? group.slice() : []
          })
        }

        // Ensure method buckets exist so the + button is available, but do not seed empty rows
        const orderingManagement = this.getLocationOrderingManagement(loc)
        orderingManagement.forEach((ordering) => {
          const deliveryMethod = ordering.type
          if (!deliveryMethod) {
            return
          }
          if (!Object.prototype.hasOwnProperty.call(delivery, deliveryMethod)) {
            delivery[deliveryMethod] = []
          }
        })

        return delivery
      },
      overrideLocationTitle (locId) {
        const idx = this.getObjectByElemKeyValue('id', locId, this.overrideLocations)
        if (idx === false || !this.overrideLocations[idx]) {
          return locId
        }
        return this.overrideLocations[idx].name
      },
      showThisOverrideLocation (locId) {
        if (!this.selectedLocations || !this.selectedLocations.length) {
          return this.getObjectByElemKeyValueBool('id', locId, this.overrideLocations) ? 1 : 0
        }
        const overrideLocIdx = this.getObjectByElemKeyValue('id', locId, this.overrideLocations)
        if (overrideLocIdx === false || !this.overrideLocations[overrideLocIdx]) {
          return 0
        }
        const trueId = this.overrideLocations[overrideLocIdx].true_id
        return this.getObjectByElemKeyValueBool('id', trueId, this.selectedLocations) ? 1 : 0
      },
      updateDeliverySettings () {
        this.$nextTick(function () {
          let model = this.model

          if (!Array.isArray(model.override_settings)) {
            Vue.set(this.model, 'override_settings', [])
          }

          let deliveryDetails = []
          let locationSource = this.overrideLocations || []

          if (this.selectedLocations && this.selectedLocations.length) {
            locationSource = this.overrideLocations.filter(loc => {
              return this.getObjectByElemKeyValueBool('id', loc.true_id, this.selectedLocations)
            })
          }

          if (!locationSource.length) {
            locationSource = this.overrideLocations || []
          }

          for (let loc of locationSource) {
            if (!loc) continue

            let idx = this.getObjectByElemKeyValue('loc_id', loc.id, model.override_settings)
            let existing = (idx !== false && idx !== null && idx !== undefined)
              ? model.override_settings[idx]
              : null

            deliveryDetails.push({
              loc_id: loc.id,
              delivery: this.buildLocationDeliveryMap(loc, existing ? existing.delivery : null)
            })
          }

          Vue.set(this.model, 'override_settings', deliveryDetails)
        })
      },
      handleErrors (errors) {
        for (var prop in errors) {
          if (errors.hasOwnProperty(prop)) {
                // console.warn(prop)
            this.errors.add(prop, errors[prop])
          }
        }
      },
      isNew () {
        if (this.route.params.id) {
          return false
        } else {
          return true
        }
      },
      handleImgChange (file, fileList) {
        // const isJPG = file.type === 'image/jpeg'
        const isOkSize = file.size / 1024 / 1024 < 5
        var self = this
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            text: self.$t('general.pictureSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          })
          this.$refs.upload.clearFiles()
          this.model.imagelist = []
        } else {
          if (fileList.length > 1) {
            this.model.imagelist = fileList.slice(1)
          } else {
            this.model.imagelist = fileList
          }
        }
        if (this.model.imagelist && this.model.imagelist[0].status === 'ready') {
          this.getBase64(this.model.imagelist[0].raw).then(
            (base64enc) => {
              this.model.image = base64enc
              this.deleteImage = false
            }
          )
        }
      },
      handleRemove (file, fileList) {
        if (fileList.length === 0) {
          this.model.imagelist = []
          this.model.image = null
          this.deleteImage = true
        }
      },
      uploadImage (upload) {
      },
      handleExceed (files, fileList) {
        swal({
          text: this.$t('general.removePhoto'),
          type: 'warning',
          showConfirmButton: true
        })
      },
      beforeUpload (file) {
        const isOkSize = file.size / 1024 / 1024 < 5
        var self = this
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            title: self.$t('general.pictureSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          })
        }
        return isOkSize
      },
      updateDates (dates) {
        this.model.date_validfrom = moment(String(dates.minDate)).format('YYYY-MM-DD')
        this.model.date_validto = moment(String(dates.maxDate)).format('YYYY-MM-DD')
      },
      handleDelete (label) {
        var btnCounter = 3
        var self = this
        swal({
          text: this.$t('catalogCateg.areYouSure', {label: label}),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes') + ' (' + btnCounter + ')'
        })
        .then((result) => {
          if (result) {
            if (this.isNew()) {
              // self.$router.push('/categories')
              self.$bus.$emit('refresh')
              self.$bus.$emit('close-modal')
            } else {
              var id = this.route.params.id
              var data = {
                id: id,
                token: this.$session.get('token'),
                company_id: this.$session.get('selectedCompany')
              }
              this.apiRequest('/category/' + id, 'DELETE', data, function (response) {
                // console.warn(response)
                if (response.status === true) {
                  self.trackAdminEvent('ADMIN_CATEGORY_DELETED', 'category', id, {
                    category_id: id,
                    name: (self.model && self.model.name) || null
                  })
                  swal(
                    '',
                    self.$t('catalogCateg.categDeleted'),
                    'success'
                  )
                  self.$bus.$emit('refresh')
                  self.$bus.$emit('close-modal')
                } else {
                  swal(
                    '',
                    response.errors['id'] ? response.errors['id'] : self.$t('validations.wentWrong'),
                    'error'
                  )
                }
              })
            }
          }
        })
        swal.disableConfirmButton()

        var btnInterval = setInterval(function () {
          btnCounter--

          if (btnCounter >= 1) {
            swal.getConfirmButton().textContent = self.$t('general.yes') + ' (' + btnCounter + ')'
          } else {
            swal.getConfirmButton().textContent = self.$t('general.yes')
            clearInterval(btnInterval)
            swal.enableConfirmButton()
          }
        }, 1000)
      },
      saveCategory () {
        this.$nextTick(function () {
          this.loading = true
        })
        var data = this.model
        data.token = this.$session.get('token')
        data.company_id = this.$session.get('selectedCompany')
        data.version = 3
        data.delete_image = this.deleteImage
        data.override_delivery = !!(
          data.override_delivery === true ||
          data.override_delivery === 1 ||
          data.override_delivery === '1'
        )
        data.delete_overrides = this.deleteOverrides
        data.is_age_restrict = !!data.is_age_restrict

        if (data.override_settings && data.override_settings.length) {
          data.override_settings.forEach(item => {
            item.version = 2
          })
        }

        if (this.has_charisma_location) {
          data.administrationsToDelete = this.administrationsToDelete
        }

        if (this.has_charisma_location && this.model.administrations && this.model.administrations.length) {
          const cleanedAdministrations = this.model.administrations.map(admin => ({
            ...admin,
            location_ids: admin.location_ids.map(loc => (typeof loc === 'object' ? loc.id : loc))
          }))
          data.administrations = cleanedAdministrations
        }

        // Build locations payload with info about added/removed locations (as in TopCategoryForm)
        const originalItems = Array.isArray(this.originalLocationIds) ? this.originalLocationIds : []
        const originalMap = {}
        const originalIds = originalItems.map(item => {
          if (item && typeof item === 'object') {
            const locId = item.location_id
            const relId = item.id || locId
            if (locId) {
              originalMap[locId] = relId
              return locId
            }
          }
          originalMap[item] = item
          return item
        })

        const currentIds = Array.isArray(this.selectedLocations)
          ? this.selectedLocations.map(l => l && l.id).filter(Boolean)
          : []

        const locationsPayload = []

        if (Array.isArray(this.selectedLocations) && this.selectedLocations.length) {
          this.selectedLocations.forEach(loc => {
            if (!loc || !loc.id) return
            const locId = loc.id
            const relationId = originalMap[locId] || null
            locationsPayload.push({
              id: relationId,
              location_id: locId,
              name: loc.name
            })
          })
        }

        if (originalIds.length) {
          originalIds.forEach(id => {
            if (!currentIds.includes(id)) {
              locationsPayload.push({
                id: originalMap[id] || id,
                location_id: id,
                delete: true
              })
            }
          })
        }

        data.locations = locationsPayload

        if (data.fromto && data.fromto[0] && data.fromto[1]) {
          data.date_validfrom = data.fromto[0]
          data.date_validto = data.fromto[1]
        } else {
          data.date_validfrom = null
          data.date_validto = null
        }

        if (this.selectedPlatforms && this.selectedPlatforms.length) {
          data.hide_from_platforms = this.selectedPlatforms.map(element => {
            return element.id
          })
        } else {
          data.hide_from_platforms = []
        }

        data.disabled_order_sources = (this.selectedDisabledOrderSources || []).map(source => source.id)

        // Empty means "inherit" (fall back to top category / company), so send null.
        if (data.monetary_conversion === '' || typeof data.monetary_conversion === 'object') {
          data.monetary_conversion = null
        }

        data.user_labeling_ids = (this.selectedUserLabelings || []).map(item => typeof item === 'object' ? item.id : item)

        let httpMethod = ''
        let url = '/category/'

        if (this.isNew()) {
          httpMethod = 'POST'
        } else {
          httpMethod = 'PUT'
          url += this.route.params.id
        }

        delete data.parent_category

        this.apiRequest(url, httpMethod, data, (response) => {
          if (response.status) {
            const entityId = (this.route.params && this.route.params.id) ||
              (response.data && response.data[0] && response.data[0].id) ||
              null
            this.trackAdminEvent('ADMIN_CATEGORY_UPDATE', 'category', entityId, {
              category_id: entityId,
              name: (this.model && this.model.name) || null,
              active: !!(this.model && this.model.active),
              request: data,
              response: response
            })
            this.$nextTick(function () { this.loading = false })
            swal(
              {
                title: '',
                text: this.$t('catalogCateg.categAdded'),
                type: 'success',
                showConfirmButton: false,
                timer: 1500
              }
            ).catch(() => {}) // end swal
            // this.router.push('/categories/edit/' + response.data[0].id)
            this.$bus.$emit('refresh')
            this.$bus.$emit('close-modal')
            this.mapLocationIdsToObjects()

            const respLocations = response.data[0].locations

            if (respLocations && respLocations.length) {
              this.originalLocationIds = respLocations.slice()
              this.selectedLocations = respLocations
                .map(item => {
                  return this.locations.find(loc => loc.id === item.location_id)
                })
                .filter(Boolean)
            } else {
              this.originalLocationIds = []
              this.selectedLocations = []
            }

            if (response.data[0].override_settings) {
              this.model.override_settings = response.data[0].override_settings
            }
            this.model.override_delivery = !!(
              response.data[0].override_delivery === true ||
              response.data[0].override_delivery === 1 ||
              response.data[0].override_delivery === '1'
            )
            this.deleteOverrides = []
            this.updateDeliverySettings()
          } else {
            this.$nextTick(function () { this.loading = false })
            swal(
              {
                title: '',
                text: response.errors.error,
                type: 'error',
                showConfirmButton: false,
                timer: 5000
              }
            ).catch(() => {}) // end swal
          }
        })
      },
      onSortOrderInput (item) {
        if (item.sort_order < 0) {
          item.sort_order = 0
        } else if (item.sort_order > 1000) {
          item.sort_order = 1000
        }

        this.sortOrderChanges[item.id] = item.sort_order

        if (this.debounceTimeout) {
          clearTimeout(this.debounceTimeout)
        }

        this.debounceTimeout = setTimeout(() => {
          this.sendSortOrderUpdates()
        }, 1000 * 5)
      },
      sendSortOrderUpdates () {
        const updates = Object.entries(this.sortOrderChanges).map(([id, sortOrder]) => ({
          id: parseInt(id),
          sortOrder: sortOrder
        }))

        if (!updates.length) {
          return
        }

        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          category_id: parseInt(this.route.params.id),
          updates: updates
        }

        this.loading = true

        this.apiRequest('/sort-product-mass-update', 'PUT', data, (response) => {
          if (response.status) {
            this.getProducts()
          } else {
            this.loading = false
            swal(
              {
                title: '',
                text: (response.errors && (response.errors.message || response.errors.error)) || this.$t('validations.wentWrong'),
                type: 'error',
                showConfirmButton: false,
                timer: 5000
              }
            ).catch(() => {})
          }
        })

        this.sortOrderChanges = {}
        this.debounceTimeout = null
      },
      onlyDigits (event) {
        const char = String.fromCharCode(event.which)
        if (!/^\d$/.test(char)) {
          event.preventDefault()
        }
      },
      selectInputText (event) {
        event.target.select()
      },
      getProducts () {
        this.loading = true
        var self = this
        const idCateg = this.route.params.id
        if (!idCateg) {
          this.loading = false
          return
        }
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          grouped: 1,
          category_id: idCateg,
          use_sort_order: 'asc'
        }
        this.apiRequest('/category-products', 'GET', data, function (response) {
          if (response.status === true) {
            self.tableData = response.data
            self.loaded = true
          }
          self.$nextTick(function () {
            self.loading = false
          })
        })
      },
      fetchUserLabelings () {
        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/userlabeling', 'GET', data, (response) => {
          if (response.status === true && response.data && Array.isArray(response.data.items)) {
            this.userLabelings = response.data.items
          }
        })
      },
      getFilters () {
        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/filter', 'GET', data, (response) => {
          if (response.status === true) {
            this.filters = response.data
            this.$nextTick(() => {
              this.loading = false
            })
          }
        })
      },
      showMethods () {
        if (!this.model.is_force_method) {
          this.model.force_methods = null
        }
      },
      changeTopCategory () {
        if (this.model.top_category_id !== 'null' && this.model.top_category_id !== null) {
          this.model.is_force_method = false
          this.model.force_methods = null
        }
      },
      addRow () {
        if (!this.model.administrations) {
          Vue.set(this.model, 'administrations', [])
        }

        this.model.administrations.push({
          id: null,
          company_id: this.$session.get('selectedCompany'),
          administration_id: null,
          location_ids: []
        })
      },
      removeRow (index) {
        const removed = this.model.administrations[index]

        if (removed.id) {
          this.administrationsToDelete.push(removed.id)
        }

        this.model.administrations.splice(index, 1)
      },
      availableAdministrations (currentId) {
        const used = this.model.administrations.map(r => r.administration_id).filter(id => id !== currentId)
        return this.administrations.filter(a => !used.includes(a.id))
      },
      goBack () {
        this.$bus.$emit('refresh')
        this.$bus.$emit('close-modal')
      },
      mapLocationIdsToObjects () {
        const administrations = this.model.administrations

        administrations.forEach(admin => {
          if (Array.isArray(admin.location_ids)) {
            admin.location_ids = admin.location_ids
              .map(id => this.locations.find(loc => loc.id === id))
              .filter(loc => loc)
          }
        })
        this.model.administrations = administrations
      }
    }
  }
</script>
<style>
  span.el-select__tags-text {
    color: #fff;
  }
  .el-select {
    width: 100%;
  }
  .selectMethod {
    width: 100%;
  }
  .section-header {
    display: flex;
    align-items: center;
    padding: 16px 20px;
    border-bottom: 1px solid #ececf3;
  }
  .section-header__icon {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
  .section-header__title {
    margin: 0;
    font-size: 15px;
    font-weight: 600;
    color: #2c2c2c;
  }
  .reward-card__help {
    font-size: 13px;
    color: #9a9a9a;
    margin: 0 0 14px;
  }
  .reward-card__control {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .reward-card__control span {
    font-size: 15px;
    white-space: nowrap;
  }
  .reward-card__control input.form-control {
    flex: 0 0 auto;
    width: 110px;
    margin: 0 10px;
  }
  .translations-card .translations-title {
    margin: 0 0 15px 0;
    font-size: 14px;
    font-weight: 600;
    color: #66615b;
  }
  .translations-card .lang-tabs {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 2px;
    margin-bottom: 18px;
    border-bottom: 1px solid #e3e3e3;
  }
  .translations-card .lang-tab {
    cursor: pointer;
    padding: 6px 14px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    color: #9a9a9a;
    background: transparent;
    border: none;
    border-bottom: 2px solid transparent;
    margin-bottom: -1px;
    transition: color .15s ease, border-color .15s ease;
    user-select: none;
  }
  .translations-card .lang-tab:hover {
    color: #674BD2;
  }
  .translations-card .lang-tab.active {
    color: #674BD2;
    border-bottom-color: #674BD2;
  }
  .translations-card .lang-tab.errorT {
    color: #ef8157;
  }
  .translations-card .lang-tab.errorT.active {
    border-bottom-color: #ef8157;
  }
  .translations-card .form-group {
    margin-bottom: 15px;
  }
  .category-override-group {
    margin-bottom: 24px;
    clear: both;
  }
  .category-override-help {
    display: block;
    margin: 6px 0 12px;
    line-height: 1.4;
  }
  .category-override-collapse {
    margin: 12px 0 8px;
    border-top: 1px solid #ebeef5;
  }
  .category-override-collapse .el-collapse-item__header {
    height: auto;
    min-height: 48px;
    line-height: 1.4;
    padding: 12px 0;
  }
  .category-override-collapse .el-collapse-item {
    margin-bottom: 4px;
  }
  .category-override-method {
    margin-bottom: 16px;
  }
  .category-override-interval {
    margin-bottom: 8px;
  }
  .category-override-days {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Categories/CategoryForm.vue